import { useDragWatch3 } from "@mobx/hooks/useDragWatch3";
import connectionsStore from "@mobx/store/connections";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo, useRef } from 'react';
import styles from './index.module.scss';

export type DragWatch3 = ReturnType<typeof useDragWatch3>;

interface DraggerProps3 {
  ctrl: DragWatch3;
  placeID?: number;
}

export const Dragger3 = observer((props: DraggerProps3) => {
  const ctrl = props.ctrl;
  const self = useRef<HTMLDivElement | null>(null);
  const dragStore = useMemo(() => props.placeID ? connectionsStore.getPlaceStore(props.placeID).drag : undefined, [props.placeID])

  useEffect(() => {
    if (!self.current) return;
    while (self.current.firstChild) {
      self.current.lastChild && self.current.removeChild(self.current.lastChild);
    }
    for (const clone of ctrl.clones) self.current.appendChild(clone);
  }, [ctrl.clones]);

  //useEffect(() => { console.log(">>> SHIFT", ctrl.pos, shift) }, [shift, ctrl.pos]);

  if (!ctrl) return <></>;
  return <div
    className={cn(styles.dragContainer, {
      [styles.dragged]: ctrl.isDrag,
    })}
    style={{
      left: dragStore?.mousePos?.x ?? 0,
      top: dragStore?.mousePos?.y ?? 0,
      transform: `translate(${dragStore?.shift?.x ?? 0}px, ${dragStore?.shift?.y ?? 0}px)`,
      minWidth: ctrl.size.x,
      minHeight: ctrl.size.y,
      //border: "2px solid black",
    }}
    ref={self}
  />
});

Dragger3.displayName = "Dragger3";
